module.exports = __webpack_public_path__ + "static/img/openClawBanner1.21728aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/config/openClawBanner1.png
// module id = hxaN
// module chunks = 3